<template>
  <div class="container question-type" v-if="gameStarted && showQuestionTypeButtons && !showDonationScreen">
    <div class="row top">
      <div class="regular truth-button" @click="setQuestionType('truth')" v-track-click="'truth_button'">
        <img src="/images/truth.webp" alt="truth button" width="250">
      </div>
    </div>
    <div class="row bottom">
      <img src="/images/or.webp" alt="or" class="or-text">
      <div class="juicy" @click="setQuestionType('juicy')" v-track-click="'juicy_button'">
        <img src="/images/juicy.webp" alt="juicy button" width="250">
      </div>
    </div>
    <label class="adult-toggle" @click.prevent="toggleAdultQuestions" v-track-click="'adult_toggle'">
      <span class="adult-toggle-text">Include adult questions</span>
      <input type="checkbox" v-model="omitAdultQuestions" style="display: none;" />
      <div class="toggle-slider" :class="{ 'enabled': !omitAdultQuestionsValue }"></div>
    </label>
    <a href="#" class="rules-link" @click.prevent="openRulesDirectly" v-track-click="'rules_link_shortcut'">Rules</a>
  </div>
</template>

<script>
import { useStore } from '../store';
import { mapState, mapActions } from 'pinia';

export default {
  computed: {
    ...mapState(useStore, ['gameStarted', 'showQuestionTypeButtons', 'showDonationScreen']),
    omitAdultQuestions: {
      get() {
        return useStore().omitAdultQuestions;
      },
      set(value) {
        useStore().omitAdultQuestions = value;
      },
    },
    omitAdultQuestionsValue() {
        return useStore().omitAdultQuestions;
    }
  },
  methods: {
    ...mapActions(useStore, ['setQuestionType', 'toggleAdultQuestions']),
    openRulesDirectly() {
      const store = useStore();
      store.showGameRules = true;
      store.showSuggestionModal = false;
      store.showDonationScreen = false;
      store.showPrivacyPolicy = false;
    },
  },
};
</script>

<style scoped>
.question-type {
    z-index: 1;
}

.question-type::before {
    content: "";
    position: absolute;
    left: -10%;
    width: 90vw;
    height: 48vh;
    background-image: url('@/../public/images/question_type.webp');
    background-size: contain;
    background-position: top left;
    background-repeat: no-repeat;
    z-index: -1;
    transition: filter 0.3s ease;
}

.prompt {
    color: var(--raspberry-pink);
    text-align: center;
    width: 50%;
    font-weight: 600;
    margin-top: 90px;
}

.or-text {
    font-size: 2rem;
    text-shadow:
        0.5px 0 0 currentColor,
        1px 0 0 currentColor,
        1.5px 0 0 currentColor;
    color: var(--coral);
    margin: 0 1rem;
    text-align: center;
    max-width: 60px;
    max-height: 40px;
    width: auto;
    height: auto;
    padding: 25px 0;
    margin-top: -38px;
    margin-bottom: 30px;
}

.question-type .bottom {
    justify-content: center;
    align-items: center;
    margin-top: -35vh;
    padding-top: 0;
    height: auto;
    min-height: 60vh;
}

.question-type .adult-toggle {
    position: fixed;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
}

body.dark-mode .question-type::before {
    filter: brightness(0.5) contrast(1.2);
}

.question-type.container {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
}

.question-type .row {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50%;
}

.question-type .top {
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
}

.question-type .bottom {
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
}

.adult-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    font-size: 20px;
    padding: 10px 0;
    width: 100%;
    cursor: pointer;
    transition: transform 0.2s ease;
}

.adult-toggle:active {
    transform: scale(0.95);
}

.adult-toggle .toggle-slider {
    margin-left: 0;
    width: 40px;
    height: 20px;
    background-color: #e0b7a0;
    position: relative;
    border-radius: 34px;
    transition: background-color 0.2s ease;
}

.adult-toggle .toggle-slider:before {
    content: "";
    position: absolute;
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background-color: #fff;
    border-radius: 50%;
    transition: transform 0.2s ease;
}

.adult-toggle .toggle-slider.enabled {
    background-color: var(--raspberry-pink);
}

.adult-toggle .toggle-slider.enabled:before {
    transform: translateX(20px);
}

.adult-toggle .toggle-slider {
    order: -1;
}

.regular {
    cursor: pointer;
    transition: transform 0.2s ease;
    position: relative;
    z-index: 5;
}

.regular:active {
    transform: scale(0.95);
}

.juicy {
    cursor: pointer;
    transition: transform 0.2s ease;
    position: relative;
    z-index: 5;
}

.juicy:active {
    transform: scale(0.95);
}

.truth-button {
    margin-top: 150px;
}

.rules-link {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    color: var(--coral);
    text-decoration: none;
    font-size: 18px;
    padding: 8px 16px;
    transition: all 0.2s ease;
    text-shadow:
        0.5px 0 0 currentColor,
        1px 0 0 currentColor;
}

.rules-link:hover {
    color: var(--raspberry-pink);
    transform: translateX(-50%) scale(1.05);
}

.rules-link:active {
    transform: translateX(-50%) scale(0.95);
}

body.dark-mode .rules-link {
    color: var(--peach);
}

body.dark-mode .rules-link:hover {
    color: var(--coral);
}
</style>
